export default __webpack_public_path__ + "components/weather-icon/static/nightlightrain-8ad6420774b725d944e28511821f4fdb.webp";